import * as _ from 'lodash'
import { required, helpers } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'

/**
 * Model "class" for Anthropometrics - defines useful field metadata for building and validating forms
 */

const maxLengthIfNonEmpty = (value) => {
    return !helpers.req(value) || value.length <= 255
}

export default {
    fields: {
        weight_lb: {
            label: 'FIELD_ANTHROPOMETRICS_WEIGHT_LB',
            type: 'number',
        },
        height_in: {
            label: 'FIELD_ANTHROPOMETRICS_HEIGHT_IN',
            type: 'number',
        },
        waist_in: {
            label: 'FIELD_ANTHROPOMETRICS_WAIST_IN',
            type: 'number',
        },
        bp_systolic: {
            label: 'FIELD_ANTHROPOMETRICS_SYSTOLIC',
            type: 'number',
        },
        bp_diastolic: {
            label: 'FIELD_ANTHROPOMETRICS_DIASTOLIC',
            type: 'number',
        },
        comment: {
            label: 'FIELD_COMMENT',
            type: 'text',
        },
    }
}
